export default function getDiscountTotal(items) {
  if (items === undefined) return 0
  return items
    .map((item) => {
      return item.discount * item.quantity || 0
    })
    .reduce((a, b) => a + b, 0)
}
